module.exports = "/images/icon_ionic_ios_document.svg?3d8e04baea6caa58528760fcd22f847b";